export const State = {
	/**
	 * Currently edited Snap Block post ID
	 */
	currentPostId: null,

	/**
	 * Cached conditions keyed by post ID
	 * Hydrated on page load from localized script
	 */
	conditionsCache: {},

	/**
	 * Initialize state from localized data
	 * @param initialConditions
	 */
	init(initialConditions = {}) {
		this.conditionsCache = { ...initialConditions };
	},

	/**
	 * Get conditions for current post
	 */
	getCurrent() {
		if (!this.currentPostId) {
			return {};
		}
		return this.conditionsCache[this.currentPostId] || {};
	},

	/**
	 * Update cache for a post
	 * @param postId
	 * @param data
	 */
	set(postId, data) {
		this.conditionsCache[postId] = { ...data };
	},

	/**
	 * Reset active post context
	 */
	reset() {
		this.currentPostId = null;
	},

	/**
	 * Remove post data from state completely
	 * @param postId
	 */
	remove(postId) {
		if (!postId) {
			console.warn('State.remove called without postId');
			return;
		}

		delete this.conditionsCache[postId];

		if (this.currentPostId === postId) {
			this.currentPostId = null;
		}
	},
};
